// ─── ALQOS™ — Nivel de madurez Calidad Asegurada (Bronce/Plata/Oro) ──
// Fuente única usada por AssuredQuality.js y DashboardCA.js.
// Antes había dos implementaciones independientes con criterios distintos
// para "Oro" (AssuredQuality exigía docsVencidos===0 y auditoriasEjecutadas>0,
// DashboardCA no) — un mismo tenant podía ver "Oro" en el dashboard interno
// y "Plata" en el reporte exportado a un cliente. Se unificó con el criterio
// más estricto de los dos, porque esta insignia se muestra a clientes del
// cliente y es peor mostrar "Oro" de más que de menos.
export function calcularNivelCA(kpis, umbrales = {}) {
  const {
    ncAbiertas = 0,
    accionesVencidas = 0,
    fmeaCriticos = 0,
    tienePCActivo = false,
    tieneAccionesVinculadas = false,
    tpmVencidos = 0,
    docsVencidos = 0,
    auditoriasEjecutadas = 0,
    totalRegistros = 0,
  } = kpis || {};
  const oroNC = umbrales.oroNC ?? 5;
  const plataNC = umbrales.plataNC ?? 10;

  if (totalRegistros === 0) {
    return { nivel:"Sin datos", icono:"⬜", color:"#808085", colorBg:"#f0f0f0", descripcion:"No hay datos cargados en el sistema todavía.", puntaje:0 };
  }
  if (ncAbiertas<oroNC && accionesVencidas===0 && fmeaCriticos===0 && tienePCActivo && tpmVencidos===0 && docsVencidos===0 && auditoriasEjecutadas>0) {
    return { nivel:"Oro", icono:"🥇", color:"#f59e0b", colorBg:"#fefce8", descripcion:"Sistema maduro orientado a prevención y mejora continua.", puntaje:100 };
  }
  if (ncAbiertas<plataNC && accionesVencidas===0 && tieneAccionesVinculadas) {
    return { nivel:"Plata", icono:"🥈", color:"#6b7280", colorBg:"#f9fafb", descripcion:"Sistema controlado con gestión efectiva de no conformidades.", puntaje:65 };
  }
  return { nivel:"Bronce", icono:"🥉", color:"#cd7f32", colorBg:"#fdf8f0", descripcion:"Sistema implementado con oportunidades de mejora en control de desvíos.", puntaje:30 };
}
